export interface CreateFacilityContactDto {
  contactType: string; // Required, max 50 characters
  firstName: string; // Required, max 100 characters
  lastName: string; // Required, max 100 characters
  title?: string | null; // Optional, max 100 characters
  email?: string | null; // Optional, Email validation, max 255 characters
  phone?: string | null; // Optional, Phone validation, max 20 characters
  isPrimary?: boolean; // Default false
}
